/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'workorderCancel': {
    width: 250,
    height: 250,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M512 45.373C254.29 45.373 45.373 254.29 45.373 512S254.29 978.627 512 978.627 978.627 769.71 978.627 512 769.71 45.373 512 45.373zM754.945 664.33c22.562 22.562 22.562 59.483 0 82.045l-20.511 20.511c-22.562 22.562-59.483 22.562-82.045 0L506.03 620.525l-146.36 146.36c-22.561 22.56-59.482 22.56-82.044 0l-20.511-20.512c-22.562-22.562-22.562-59.483 0-82.045l146.36-146.36-158.299-158.297c-22.562-22.562-22.562-59.483 0-82.045l20.511-20.511c22.562-22.562 59.483-22.562 82.045 0l158.298 158.3 158.298-158.3c22.562-22.56 59.483-22.56 82.045 0l20.511 20.512c22.562 22.562 22.562 59.483 0 82.045L608.586 517.969l146.36 146.36z"/>'
  }
})
